import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import HomePageHeroTitle from '../components/HomePage/HomePageHeroTitle';

import GuidesAndReportsList from '../components/GuidesAndReports/GuidesAndReportsList';
import HubSpotForm from '../components/HubSpotForm';
import caseStudiesListing from '../constants/guideAndReportsItems';
import pagesJsonLD from '../constants/pagesJsonLD';
import './CaseStudies.css';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const GuideAndReportsItem = () => {
  const query = useQuery();
  const caseStudyUrl = query.get('item');
  //alert(caseStudyUrl);
  const getCaseStudyByUrl = (url) => {
    return caseStudiesListing.find((caseStudy) => caseStudy.url === url);
  };
  const caseStudy = getCaseStudyByUrl(caseStudyUrl);

  if (!caseStudy) {
    return (
      <div className="holder notFoundPage">
        <img src="/notFoundImage.png" alt="" />
        <div className="contentNotFound">
          <h1>404</h1>
          <p>even AI can't help you find what you are looking for...</p>
          <a href="/" className="button-name5">
            Go back home
          </a>
        </div>
      </div>
    );
  }
  return (
    <div className="case-studies">
      <Helmet>
        <title>Releva AI | Case Study</title>
        <meta
          name="description"
          content="Explore Releva AI's case studies to see how our AI-driven solutions have transformed businesses. Discover real-world examples of enhanced customer engagement, increased conversions, and optimized marketing strategies. Learn from our success stories."
        />
        <script type="application/ld+json">{JSON.stringify(pagesJsonLD.caseStudiesPage)}</script>
      </Helmet>

      <div className="case-studies locked">
        <section className="section-01-wrapper">
          <div className={`section-01 guideAndReport`}>
            <div className="section-01-inner">
              <div className="hi-john-message-parent">
                <HomePageHeroTitle heroTitle={caseStudy.heroTitle} heroDescription={caseStudy.heroDescription} />
                <div className="streamline-abandoned-cart-reco-parent guideAndReport">
                  <div dangerouslySetInnerHTML={{ __html: caseStudy.content }} />
                </div>
              </div>
            </div>
            <div className="frame-parent33">
              <div className="automate-retargeting-of">
                <HubSpotForm idForm={caseStudy.idForm} />
              </div>
            </div>
          </div>
        </section>
      </div>
      <h1 className="checkOutMoreTitle">Check out more Reports & Guides.</h1>
      <GuidesAndReportsList category={'All'} />
    </div>
  );
};

export default GuideAndReportsItem;
